import * as React from 'react';

import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';

import Modal from 'src/components/common/Modal';
import Input from 'src/components/common/Input';

import './CreditsVoidModal.scss';

interface ICreditVoidModalProps {
  voidCredit: (databaseId: number, note: string) => void;
  handleCloseModal: () => void;
  paymentId: number;
}

interface ICreditVoidModalState {
  note: string;
}

class CreditVoidModal extends React.Component<
  ICreditVoidModalProps,
  ICreditVoidModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      note: ''
    };
  }

  private onChangeNote = (note: string) => {
    if (!note || (note !== ' ' && !startEndWithWhiteSpacesValidation(note))) {
      this.setState({
        note
      });
    }
  };

  public render() {
    return (
      <Modal handleCloseModal={this.props.handleCloseModal}>
        <div className="rp-credits-void-modal">
          <span
            onClick={e => this.props.handleCloseModal()}
            className="rpds-close rp-credits-void-modal--close-icon"
          />
          <div className="rp-credits-void-modal--title">
            Are you sure you want to void this payment?
          </div>
          <div className="rp-credits-void-modal--text">
            Add a reason under the note input field and click continue to void
            this payment.
          </div>
          <Input
            className={'rp-credits-void-modal--input'}
            label={'Note:'}
            value={this.state.note}
            onChange={this.onChangeNote}
            required={true}
          />
          <div className="rp-credits-void-modal--buttons">
            <button
              className="secondary-button"
              onClick={this.props.handleCloseModal}
            >
              Cancel
            </button>
            <button
              className={`primary-button ${this.state.note ? '' : 'disabled'}`}
              onClick={e =>
                this.props.voidCredit(this.props.paymentId, this.state.note)
              }
              disabled={!this.state.note}
            >
              Continue
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreditVoidModal;
